import React from "react";

export default function AdminBlockingModal({ title, message, onClose }) {
  if (!message) return null;
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-slate-900/50 px-4">
      <div className="card w-full max-w-md p-6 text-center">
        <h2 className="text-lg font-semibold text-slate-900">
          {title || "Action blocked"}
        </h2>
        <p className="mt-2 text-sm text-slate-600">{message}</p>
        <button className="btn btn-primary mt-4 w-full" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
